import request from '@/utils/request'

export default {
    vipRecharge: function (query) {
        return request({
            url: 'wxPay/vipRecharge',
            method: 'post',
            params: {
                openId: query.openId,
                uid: query.uid,
                goodsId: query.goodsId,
                goodsName: query.goodsName,
                traderId: query.traderId,
            }
        });
    },
    charge: function (query) {
        return request({
            url: 'wxPay/charge',
            method: 'post',
            data: query
        });
    },
    queryOrderList: function (form) {
        return request({
            url: 'wxPay/list',
            method: 'post',
            data: form
        });
    },
    queryOrderListSub: function (form) {
        return request({
            url: 'wxPay/listSub',
            method: 'post',
            data: form
        });
    },
    queryOrderLogList: function (form) {
        return request({
            url: 'wxPay/logList',
            method: 'post',
            data: form
        });
    },
    queryOrderDetail: function (id) {
        return request({
            url: 'wxPay/detail',
            method: 'post',
            params: {id:id}
        });
    },
}
